<template>
  <div>
    <div v-if="isLoading" class="text-center ma-12">
      <v-progress-circular size="48" width="4" indeterminate color="grey lighten-2"></v-progress-circular>
    </div>
    <template v-else>
      <box class="main-top-margin">
        <v-row dense>
          <v-col cols="12">
            <BoxItem type="switch" :title="$t('SETTINGS-LABEL-KEYCLOAK_ACTIVE')" :value="keycloakActive" @updateValue="keycloakActive = $event" />
            <template v-if="keycloakActive">
              <BoxItem
                :rules="[rules.required]"
                :title="$t('SETTINGS-KEYCLOAK-TOKEN_URL')"
                :value="setting.value.token_url"
                @updateValue="setting.value.token_url = $event"
              />
              <BoxItem
                :rules="[rules.required]"
                :title="$t('SETTINGS-KEYCLOAK-CLIENT_ID')"
                :value="setting.value.client_id"
                @updateValue="setting.value.client_id = $event"
              />
            </template>
          </v-col>
        </v-row>
      </box>
      <box class="mt-2" v-if="keycloakActive" background="transparent" borderColor="transparent" padding="1em 0">
        <div class="d-flex justify-end">
          <v-btn :loading="isSaving" class="general-action-btn" @click="save()" style="z-index:999;">
            <lang t="GLOBAL-BTN-SAVE" />
          </v-btn>
        </div>
      </box>
    
      <box class="main-top-margin">
        <v-row dense>
          <v-col cols="12">
            <BoxItem :title="$t('Linked Instances')" onlyTitle />
            <v-data-table
              hide-default-footer
              :headers="linkedInstancesHeader"
              :items="linkedInstances"
              :items-per-page="25"
              style="max-width: 768px;"
              class="mb-8 bundle-complete-tbl elevation-0"
            >
              <template v-slot:item.read="{ item }">
                <checkbox :value="item.read" disabled />
              </template>

              <template v-slot:item.write="{ item }">
                <checkbox :value="item.write" disabled />
              </template>

              <template v-slot:item.created_at="{ item }">
                {{ dateFormat(item.created_at) }}
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn icon @click.stop.prevent="deleteLinkedInstance(item)">
                  <v-icon small class="pa-1" color="secondary"  :disabled="!item.isDeleteable"
                    >mdi-trash-can-outline</v-icon
                  >
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" class="text-center">
                  <v-btn small text @click="dialog = true">
                    <v-icon color="#404046">mdi-plus</v-icon>
                  </v-btn>
                </v-col>
        </v-row>
      </box>
     
    </template>
    <v-dialog v-model="dialog" max-width="640px" style="z-index: 1000" >
        <v-card>
          <v-card-title>
            <span class="title1"><lang t="SETTINGS-NEW_LINKED_INSTANCES"></lang></span>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="isFormValid">
              <v-row>
                <!-- Name -->
                <v-col cols="12">
                  <BoxItem
                    :title="$t('SETTINGS-LINKDED_INSTANCE-NAME')"
                    :value="newLinkedInstance.name"
                    required
                    :rules="[(v) => !!v || $t('GLOBAL-FORM-FIELD_REQUIRED')]"
                    @updateValue="newLinkedInstance.name = $event"/>
                </v-col>
                <v-col cols="6">
                  <BoxItem
                    :title="$t('SETTINGS-LINKDED_INSTANCE-READ')"
                    :value="newLinkedInstance.read"
                    type="switch"
                    @updateValue="newLinkedInstance.read = $event"/>
                  
                </v-col>
                <v-col cols="6">
                  <BoxItem
                    :title="$t('SETTINGS-LINKDED_INSTANCE-WRITE')"
                    :value="newLinkedInstance.write"
                    type="switch"
                    @updateValue="newLinkedInstance.write = $event"/>
                  
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeDialog">{{ $t("GLOBAL-BTN-CANCEL") }}</v-btn>
            <v-btn elevation="0" class="general-action-btn" :disabled="!isFormValid" @click="saveLinkedInstance">{{
              $t("GLOBAL-BTN-SAVE")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import Box from "../../components/ui-elements/Box.vue";
import BoxItem from "../../components/ui-elements/BoxItem.vue";
import Checkbox from "../../components/ui-elements/Checkbox.vue";

export default {
  name: "SettingsIndex",
  data: () => ({
    isSaving: false,
    isLoading: true,
    setting: {},
    linkedInstances: [],
    isFormValid: false,
    dialog: false,
    newLinkedInstance: {
      name: '',
      api_key: '',
      write: false,
      read: false
    }

  }),
  components: {
    Box,
    BoxItem,
    Checkbox,
  },
  computed: {
    linkedInstancesHeader() {
      return [
        {
          text: this.$t("NAME"),
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("API KEY"),
          value: "api_key",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("READ"),
          value: "read",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("WRITE"),
          value: "write",
          align: "center",
          sortable: false,
        },

        {
          text: this.$t("CREATED AT"),
          value: "created_at",
          align: "center",
          sortable: false,
        },

        {
          text: "",
          value: "action",
          align: "center",
          sortable: false,
        },
      ];
    },

    keycloakActive: {
      get() {
        return this.setting && this.setting.value && Object.keys(this.setting.value).length > 0;
      },
      set(val) {
        if (val) {
          this.$set(this.setting, "value", { token_url: "", client_id: "" });
        } else {
          this.$set(this.setting, "value", {});
        }
      },
    },
  },

  created() {
    this.initialize();
  },

  mounted() {},

  methods: {
    initialize() {
      this.isLoading = true;

      this.axios.get("settings").then((res) => {
        this.setting = res.data.find((s) => s.name == "keycloak");
        this.isLoading = false;
      });
      this.loadLinkedInstances();
    },
    loadLinkedInstances(){

      this.axios.get("linkedinstances").then((res) => {
        this.linkedInstances = res.data;
      });
    },
    closeDialog(){
      this.dialog = false;
      this.addLinkedInstance = {
        name: '',
        api_key: '',
        read: false,
        write: false
      }
    },
    async deleteLinkedInstance(item){
      try{
        this.$confirm(
        this.$t("GLOBAL-CONFIRMATION-DELETE-MSG", { NAME: item.name }),
        {
          title: this.$t("GLOBAL-CONFIRMATION-DELETE-TITLE"),
          buttonTrueText: this.$t("GLOBAL-CONFIRMATION-DELETE-YES"),
          buttonFalseText: this.$t("GLOBAL-CONFIRMATION-DELETE-CANCEL"),
        }
      ).then(async (res) => {
        if (res) {
          await this.axios.delete(`linkedinstances/${item.id}`);
        this.loadLinkedInstances();
        this.$store.dispatch("setSnackbar", { text: this.$t("GLOBAL-SUCCESSFULLY_DELETED") });
        }
      });
        
      }catch(err){
        console.error(err);
      }
    },
    async saveLinkedInstance(){
        try{
          const output = await this.axios.post('linkedinstances',this.newLinkedInstance);
          this.linkedInstances.unshift(output.data);
          this.$store.dispatch("setSnackbar", { text: this.$t("GLOBAL-SUCCESSFULLY_DELETED") });
          this.closeDialog();
        }catch(err){
          console.error(err);
        }
    },

    save() {
      let id = 0;

      this.isSaving = true;

      this.axios
        .put("settings/" + this.setting.id, this.setting)
        .then((res) => {
          this.$store.dispatch("setSnackbar", {
            text: this.$t("GLOBAL-MESSAGE-SUCCESSFULLY_SAVED"),
          });
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>

<style lang="scss"></style>
